import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['couponInput', 'wrapper']

  showCouponInput(event) {
    $(event.currentTarget).addClass('hidden')
    $(this.wrapperTarget).removeClass('hidden')
  }

  submit(e) {
    $('.coupon_first_name').val($('#user_first_name').val())
    $('.coupon_last_name').val($('#user_last_name').val())
    
    let email = $('#user_email').val()
    if (email.length == 0) email = $('#user_email', '#email_input_box').val()
    $('.coupon_billing_email').val(email)
    $('.coupon_company_name').val($('#user_company_name').val())
    $('.coupon_contact_number').val($('#user_contact_number').val())
    $('.coupon_vat_number').val($('#user_vat_number').val())
    $('.coupon_external_reference').val($('#user_external_reference').val())
  }
}
